import WebFont from 'webfontloader';

let config = {
  google: {
    families: ['Montserrat:400,700'],
  },
  classes: true,
  events: false,
  timeout: 2000,
  /*
  loading: function() {},
  active: function() {},
  inactive: function() {},
  fontloading: function(familyName, fvd) {},
  fontactive: function(familyName, fvd) {},
  fontinactive: function(familyName, fvd) {},
  */
};

function init() {
  WebFont.load(config);
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/webfontloader.js